import TriviaGame from './TriviaGame';
import { triviaDefinition } from './triviaDefinition';

const triviaIcon = {
  id: 'arcade-trivia',
  src: `${process.env.PUBLIC_URL}/game-icons/trivia.png`,
};

export const triviaGameModule = {
  id: triviaDefinition.id,
  name: triviaDefinition.name,
  summary: triviaDefinition.summary,
  component: TriviaGame,
  definition: triviaDefinition,
  accent: 'yellow',
  icon: triviaIcon,
  releaseState: 'released',
  controls: {
    movement: 'none',
    actions: ['answer', 'confirm'],
    notes: 'Tap answers or use 1-4, arrows, Enter, and Space.',
  },
  playableIcons: [],
};
